import { FunctionComponent, useContext } from 'react';
import Skeleton from 'react-loading-skeleton';
import { ConfigContext, UserContext } from '../../context';
import { StoryCardStatus, useStoryCardsFeedQuery } from '../../services';
import { Teaser } from './Teaser';

export const SpecialTeaser: FunctionComponent = () => {
  const { channelId } = useContext(UserContext).userInfo.userData;
  const { setup } = useContext(ConfigContext).config.elements.specialTeaser;

  const storyId =
    setup.find((setupItem) => setupItem.channelId === channelId || !setupItem.channelId)?.storyId ??
    0;

  const { data, isFetching } = useStoryCardsFeedQuery(
    { storyId, size: 1, filter: { status: [StoryCardStatus.PUBLISHED] } },
    { skip: !storyId }
  );

  if (!storyId) {
    return null;
  }

  if (isFetching) {
    return <Skeleton width={'100%'} height={'14rem'} />;
  }

  if (!data?.items) {
    return null;
  }

  const topStoryCard = data.items[0];

  if (!topStoryCard) {
    return null;
  }

  return <Teaser card={topStoryCard} />;
};
